/**
 * 契約API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * ガス契約情報
 */
export interface Szma301aResponseGasCtrSearchResultDtoGasCtrMstInfo {
    /**
     * 導管事業者コード：英数字<br>　コード変換マスターテーブル.画面項目ID「C300080」のユーザコードを設定
     */
    cndtBusCode?: string;
    /**
     * 導管事業者名称：全半角混在
     */
    cndtBusAname?: string;
    /**
     * 指定日検針日区分コード：英数字<br>　コード変換マスターテーブル.画面項目ID「C300090」のユーザコードを設定
     */
    siteiKensinDiv?: string;
    /**
     * 指定日検針日区分コード名称：全半角混在
     */
    siteiKensinDivAname?: string;
    /**
     * 検針日程：数字
     */
    kensinSchdl?: string;
    /**
     * 受入地点コード：英数字<br>　コード変換マスターテーブル.画面項目ID「C300950」のユーザコードを設定
     */
    acsptPointCode?: string;
    /**
     * 受入地点コード名称：全半角混在
     */
    acsptPointCodeAname?: string;
    /**
     * 託送契約番号：英数字
     */
    cnsgmtCtrNo?: string;
    /**
     * 託送供給契約約款区分コード：英数字<br>　コード変換マスターテーブル.画面項目ID「C300960」のユーザコードを設定
     */
    chargeCategCode?: string;
    /**
     * 託送供給契約約款区分名称：全半角混在
     */
    chargeCategCodeAname?: string;
    /**
     * 総合契約区分コード：英数字<br>　コード変換マスターテーブル.画面項目ID「C410210」のユーザコードを設定
     */
    sogoCtrDiv?: string;
    /**
     * 総合契約区分名称：全半角混在
     */
    sogoCtrDivAname?: string;
    /**
     * 転売有無フラグ：英数字<br>　コード変換マスターテーブル.画面項目ID「C410020」のユーザコードを設定
     */
    resaleFlg?: string;
    /**
     * 転売有無名称：全半角混在
     */
    resaleFlgAname?: string;
    /**
     * 転売先事業者コード：英数字<br>　コード変換マスターテーブル.画面項目ID「C410220」のユーザコードを設定
     */
    resaleBusCode?: string;
    /**
     * 転売先事業者名称：全半角混在
     */
    resaleBusAname?: string;
    /**
     * 最終供給事業者コード：英数字<br>　コード変換マスターテーブル.画面項目ID「C410230」のユーザコードを設定
     */
    finalSupplierCode?: string;
    /**
     * 最終供給事業者名称：全半角混在
     */
    finalSupplierAname?: string;
    /**
     * 最終供給事業者連絡先：半角
     */
    finalSupplierTel?: string;
}

